module.exports = {
  pathPrefix: '/',
  siteTitle: 'Comfort Inn & Suites Sombrero', // Navigation and Site Title
  siteTitleShort: 'Comfort Inn & Suites Sombrero', // short_name for manifest
  siteUrl: 'https://www.sombrero.com.au', // Domain of site. No trailing slash!
  siteLogo: './src/assets/images/logo/icon.png', // Used for SEO, sharing and manifest
  author: 'Discovr Bookings' // Author for schema.org JSONLD
};
